/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_OffsetInputs */



/**
* | output |
* | --- |
* | "Apply Offset" |
*
* @param {Apply_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_offset = /** @type {((inputs?: Apply_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer le décalage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offset anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica offset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применить смещение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar desplazamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフセットを適用")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफसेट लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar deslocamento")
	return /** @type {LocalizedString} */ ("Apply Offset")
});